<template>
    <svg width="96" height="97" viewBox="0 0 96 97" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_6469_1480" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="96" height="97">
            <path d="M96 0.170898H0V96.1709H96V0.170898Z" fill="white" />
        </mask>
        <g mask="url(#mask0_6469_1480)">
            <path
                d="M59.1 13.0709C54.45 19.0709 44.4 24.0209 39.9 20.4209C35.4 16.8209 38.1 6.1709 42.9 0.170898L59.1 13.0709Z"
                fill="#FFC6C6"
            />
            <path
                d="M34.9499 72.0208C27.1499 70.6708 21.4499 69.1708 19.3499 63.9208C17.2499 58.3708 21.2999 57.0208 28.3499 57.0208C35.2499 57.0208 
                    38.0999 52.9708 38.0999 52.9708C38.0999 52.9708 24.1499 48.3208 18.5999 39.1708C17.0999 36.6208 14.8499 32.4208 16.7999 27.0208C20.0999 
                    17.2708 29.2499 13.0708 35.6999 13.5208C45.1499 14.2708 55.6499 23.7208 61.1999 35.4208C71.2499 39.4708 86.3999 48.7708 95.9999 
                    55.6708C91.6499 78.0208 74.6999 96.1708 74.6999 96.1708C74.6999 96.1708 56.5499 82.5208 47.5499 73.0708C47.5499 73.0708 40.0499 
                    72.7708 34.9499 72.0208Z"
                fill="#00D672"
            />
            <path
                d="M79.9499 30.7711C74.2499 37.5211 62.8499 42.7711 57.8999 38.4211C52.9499 34.0711 56.3999 21.6211 62.0999 14.8711L79.9499 30.7711Z"
                fill="#FFC6C6"
            />
            <path
                d="M74.6999 96.1708C74.0999 90.4708 86.9999 63.3208 95.9999 55.8208C91.1999 82.3708 74.6999 96.1708 74.6999 96.1708Z"
                fill="#FFDE1A"
            />
            <path
                d="M12.75 50.7207L12.45 47.1207L0.6 45.4707L0 51.6207L12.75 50.7207Z"
                fill="#1A2C47"
            />
            <path
                d="M15.75 56.421L13.5 54.021L6.44995 58.821L9.29995 62.721L15.75 56.421Z"
                fill="#1A2C47"
            />
            <path
                d="M14.55 43.6708L16.5 42.0208L11.4 34.8208L7.19995 37.9708L14.55 43.6708Z"
                fill="#1A2C47"
            />
            <path
                d="M51.3 18.6207C58.95 18.0207 56.85 25.5207 56.85 25.5207L58.65 23.1207C58.65 23.1207 59.85 18.6207 57.6 16.6707C55.2 14.7207 51 16.8207 51 16.8207L51.3 18.6207Z"
                fill="#FFC6C6"
            />
        </g>
    </svg>
</template>
